module.exports = __webpack_public_path__ + "9aaa94224d0d7d260e81738d8d62b4af.svg";